import { FC, useEffect, useMemo, useState } from "react";
import { DashboardDevice } from "../../../../../../models/api/DashboardDevice";
import { CurrentWidgetMeasurementConfig } from "../../../SimpleAppTemplate";
import useCurrentBatteryIndicator from "../hooks/useCurrentBatteryIndicator";
import { getIndicator } from "../../WidgetHelper";

type Props = {
  device: DashboardDevice;
  orgId?: string;
  measurement: CurrentWidgetMeasurementConfig;
};

// TODO: Informative Comment
const CurrentBatteryIndicator: FC<Props> = ({ device, orgId, measurement }) => {
  const [valueLabel, setValueLabel] = useState<string>("Battery Charge Level");
  const { fetchData, data: currentData, isLoading } = useCurrentBatteryIndicator(device.id);

  useEffect(() => {
    if (measurement) {
      // Required
      const name = measurement.name;
      const fieldKey = measurement.fieldKey;
      const maximumBattery = device.batteryMaximum ?? 0;
      const minimumBattery = device.batteryMinimum ?? 0;

      // Optional
      const displayName = measurement.displayName;
      const fieldName = measurement.fieldName;
      const label = measurement.label;
      if (label) setValueLabel(label);

      const hasError = !name || !fieldKey || !maximumBattery || !minimumBattery;
      if (!hasError) {
        const getData = async () => {
          await fetchData({
            name,
            fieldKey,
            maximumBattery,
            minimumBattery,
            displayName,
            fieldName,
            orgId,
          });
        };

        getData();
      }
    }
  }, [measurement, orgId]);

  const GetCurrentIndicator = useMemo(() => {
    return getIndicator(currentData, valueLabel, isLoading);
  }, [currentData, valueLabel, isLoading]);

  return <>{GetCurrentIndicator}</>;
};

export default CurrentBatteryIndicator;
